const PeopleContainerLoader = () => {
	return (
		<div className="people-container people-container-loader" aria-busy="true" aria-live="polite">
			<div className="people-title-loader">
				<div className="placeholder-pulse" />
			</div>
			<div className="people-description-loader">
				<div className="placeholder-pulse" />
			</div>
			<div className="people-cards-loader">
				{Array.from({ length: 8 }).map((_, i) => (
					<div className="people-card-loader" key={i}>
						<div className="people-card-image-loader placeholder-pulse" />
						<div className="people-card-text-loader" />
					</div>
				))}
			</div>
		</div>
	);
};

export default PeopleContainerLoader;
